import { render, staticRenderFns } from "./scrollUp.vue?vue&type=template&id=358ef707&scoped=true&"
import script from "./scrollUp.vue?vue&type=script&lang=ts&"
export * from "./scrollUp.vue?vue&type=script&lang=ts&"
import style0 from "./scrollUp.vue?vue&type=style&index=0&id=358ef707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ef707",
  null
  
)

export default component.exports